import { Sidebar } from '@ws/shared/components';
import { TCollection, TNote } from '@ws/shared/types';
import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EditabilityContext } from '../../context';
import { TAppState } from '../../redux';
import { setGlobalIsTkPanelOpen } from '../../redux/general/general.actions';

import { TkPanelView } from './TkPanelView';
import { useJumpToMarker } from './useJumpToMarker';
import { useTkMarkers } from './useTkMarkers';

export interface ITkPanelContainerProps {
  entity: TCollection | TNote;
}

export function TkPanelContainer({ entity }: ITkPanelContainerProps) {
  const dispatch = useDispatch();
  const { getNodesByRefs } = useContext(EditabilityContext);
  const { isTkPanelOpen } = useSelector((state: TAppState) => state.general);
  // Объект проекта меняется по ссылке на каждое событие — это и есть ревизия,
  // по которой список обязан пересчитаться.
  const { project } = useSelector((state: TAppState) => state.editor);

  const state = useTkMarkers({ entity, getNodesByRefs, revision: project });
  const jumpToMarker = useJumpToMarker();

  const handleClose = useCallback(() => {
    dispatch(setGlobalIsTkPanelOpen({ isTkPanelOpen: false }));
  }, [dispatch]);

  return (
    <Sidebar.Container
      variant="drawer"
      position="right"
      isOpen={isTkPanelOpen}
      onClose={handleClose}
    >
      <TkPanelView state={state} onClose={handleClose} onMarkerClick={jumpToMarker} />
    </Sidebar.Container>
  );
}
